export const GET_ALL_ORGANIZATIONS = () => `organization/`;
export const GET_ORGANIZATION_BY_ID = (orgId) => `organization/${orgId}`;
export const DELETE_ORGANIZATION = (orgId) => `organization/${orgId}`;
export const EDIT_ORGANIZATION = (orgId) => `organization/${orgId}`;
export const CREATE_ORGANIZATION = () => `organization/`;
